import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const defaultStyle = css `
  color: ${theme.semantic.foreground.secondary};
  background-color: color-mix(in srgb, ${theme.semantic.action.secondary.hover}, transparent 50%);
  border-color: ${theme.semantic.border.default};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.disabled};
  }

  &:disabled {
    background-color: ${theme.semantic.action.secondary.hover};
    border-color: ${theme.swatches.warm[50]};
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${theme.semantic.action.secondary.hover};
      border-color: ${theme.semantic.border.default};
    }

    &:active {
      background-color: ${theme.semantic.action.secondary.active};
      border-color: ${theme.semantic.border.default};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.focus.ring};
    }
  }
`;
const draftStyle = css `
  color: ${theme.swatches.blue[700]};
  background-color: ${theme.swatches.blue[50]};
  border-color: ${theme.swatches.blue[200]};

  [data-icon='falcon'] {
    color: ${theme.swatches.blue[600]};
  }

  &:disabled {
    background-color: ${theme.swatches.blue[50]};
    border-color: ${theme.swatches.blue[300]};
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${theme.swatches.blue[100]};
      border-color: ${theme.swatches.blue[300]};
    }

    &:active {
      background-color: ${theme.swatches.blue[200]};
      border-color: ${theme.swatches.blue[300]};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} color-mix(in srgb, ${theme.swatches.blue[100]}, transparent 50%);
    }
  }
`;
export function getFilterButtonAppearance(appearance) {
    switch (appearance) {
        case 'draft':
            return draftStyle;
        case 'default':
        default:
            return defaultStyle;
    }
}
